import { SettingsApi as Api } from 'services/api/Api';
import pages from 'services/routes/pages';
import { MMM_OPTIMIZATION_RESULTS } from 'services/routes/constants';

const MmmOptimizationResultsApiFactory = () => {
  const url = pages[MMM_OPTIMIZATION_RESULTS].endpoint;

  return {
    getList: async () => Api.get(url),
    getDetail: async (id) =>
      Api.get(`${url}/${encodeURIComponent(id)}`),
    getExportUrl: async (id) => {
      const response = await Api.get(
        `${url}/${encodeURIComponent(id)}/export-url`
      );
      const { download_url: downloadUrl, file_name: fileName } = response.data.data;
      return {
        downloadUrl,
        fileName,
      };
    },
  };
};

const MmmOptimizationResultsApi = MmmOptimizationResultsApiFactory();
export default MmmOptimizationResultsApi;
